module.exports = __webpack_public_path__ + "common/icon-email-497cf1b9fa6b57a5178fb5857f896d6f.svg";